// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S3kqY","comment":"styles_comment__3yuLd"};